import React from 'react';
import cn from 'classnames';

export default ({ color = "#6ac1ff", small }) => {
  const size = small ? 32 : 66;
  const width = `${size - 1}px`;
  const cx = size / 2;
  const r = (size - 6) / 2;
  const strokeWidth = small ? 3 : 6;
  const className = cn("spinner", { small });

  return (
    <svg className={className} width={width} height={width} viewBox={`0 0 ${size} ${size}`} xmlns="http://www.w3.org/2000/svg">
      <circle className="spinner-circle" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" cx={cx} cy={cx} r={r}></circle>
    </svg>
  );
}


// WEBPACK FOOTER //
// ./src/components/common/Spinner.js